import { render, staticRenderFns } from "./tableAllCargosExtended.vue?vue&type=template&id=02922f46&"
import script from "./tableAllCargosExtended.vue?vue&type=script&lang=js&"
export * from "./tableAllCargosExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports